import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js"; // ✅ Importato correttamente
import { Box, CssBaseline, GlobalStyles, ThemeProvider, createTheme } from "@mui/material";
import Login from "./components/HomePage/login";
import PasswordResetPage from "./components/HomePage/passwordResetPage";
import ImpersonateLogin from "./components/HomePage/impersonateLogin";
import { AuthProvider, useAuth } from "./services/providers/authProvider";
import PrivateRoute from "./services/providers/privateRoute";
import { AccessGateProvider } from "./context/accessGateContext";
import { ErrorProvider } from "./services/providers/errorProvider";
import { NotificationUnreadProvider } from "./context/notificationUnreadContext";
import { TicketUnreadProvider } from "./context/ticketUnreadContext";
import { vendorRoutes } from "./config/vendorNavRoutesConfig";
import { VENDOR_PASSWORD_RESET_PATH, VENDOR_PASSWORD_SETUP_PATH } from "./config/vendorAuthPaths";
import VendorLayout from "./components/Vendor/vendorLayout";
import { globalScrollbarStyles } from "./theme/scrollStyles";
const theme = createTheme({
  spacing: 6,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

function ImpersonationBadgeOverlay() {
  const { isImpersonated, token } = useAuth() || {};
  if (!isImpersonated || !token) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 2,
        right: 2,
        zIndex: 1600,
        bgcolor: "#f2c55c",
        color: "#213e56",
        p: "1px 2px 1px 2px",
        fontFamily: "Rubik",
        fontSize: "0.8rem",
        fontWeight: 700,
      }}
    >
      Modalità impersonificata
    </Box>
  );
}

function App() {
  return (
    <PayPalScriptProvider options={{ "client-id": "AfyCjk6GGR4KHDKRUOw63xoyq9AddpGaLKvFoT_5hWN5dHeQI-r6UU116x25cihw54gj3yS1QrcCfPlO" }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalScrollbarStyles} />
        <Router>
          <AuthProvider>
            <AccessGateProvider>
              <ErrorProvider>
                <NotificationUnreadProvider>
                <TicketUnreadProvider>
                <ImpersonationBadgeOverlay />
                <Routes>
                  <Route path="/login/vendor" element={<Login />} />
                  <Route path={VENDOR_PASSWORD_RESET_PATH} element={<PasswordResetPage />} />
                  {/* Stesso flusso, testi da prima attivazione: account creati prima della produzione */}
                  <Route path={VENDOR_PASSWORD_SETUP_PATH} element={<PasswordResetPage mode="setup" />} />
                  <Route path="/impersonate-login" element={<ImpersonateLogin />} />
                  <Route
                    element={<PrivateRoute element={<VendorLayout />} requiredRole="vendor" />}
                  >
                    {vendorRoutes.map((route) => (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={
                          route.enabled ? route.element : <Navigate to="/dashboard" replace />
                        }
                      />
                    ))}
                  </Route>
                  <Route path="*" element={<Navigate to="/login/vendor" replace />} />
                </Routes>
                </TicketUnreadProvider>
                </NotificationUnreadProvider>
              </ErrorProvider>
            </AccessGateProvider>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </PayPalScriptProvider>
  );
}

export default App;
